//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment"
import Mapbox from 'mapbox-gl-vue'
import { mapActions, mapState } from 'vuex'
import stateList from '../../assets/src/usstates.json'

export default {
    components: { Mapbox },
    beforeMount() {
        this.locationSearch({ address: this.location.address + ' ' + this.location.city + ' ' + this.location.zip })
    },
    data() {
        return {
            accessToken: process.env.MAPBOX_TOKEN,
            mapStyle: 'mapbox://styles/mapbox/dark-v10',
            // header: this.location.address.replace(/[0-9]/g, '') +  ' Krystal' , //trim numbers for address, only use street name
            servicesHidden: true,
            locationsHidden: true,
            column1: [1, 2, 3, 4], // monday - thursday
            column2: [5, 6, 0] // friday - sunday
        };
    },
    head() {
        return {
            title: this.location.city + ', ' + this.location.state,
            script: [
                {
                    src: 'https://knowledgetags.yextpages.net/embed?key=007_4DrvCtyXazLGR_1iU5nJ_b13V8-OFoVBENp5oP7U7IKvDKXctOLevRmLv29t&account_id=7112809083039550790&entity_id=' + this.location.id + '&locale=en&v=20210504',
                    async: true
                }
            ]
        }
    },
    props: {
        location: {
            type: Object,
            default: () => { },
        },
    },
    computed: {
        ...mapState(['order', 'options', 'locationList']),
        header() {
            let words = this.location.address.split(' ')
            let name = ''
            for (var i = 0; i < words.length; i++) {
                if (isNaN(words[i])) {
                    name = name + ' ' + words[i]
                }
            }
            name = name + ' Krystal'
            return name
        },
        center() {
            return [this.location.lng, this.location.lat]
        },
        dayOfWeek() {
            return parseInt(moment().format('e'))
        },
        geojson() {
            let geojson = {
                'type': 'FeatureCollection',
                'features': []
            }
            let l = this.location
            let closed = l.closed ? 'Closed' : 'Open Now'
            let feature = {
                'type': 'Feature',
                'properties': {
                    'id': l.id,
                    'available': l.available,
                    'title': l.address + '<br> ' + l.city + ', ' + l.state + ' ' + l.zip,
                    // 'distance': l.distance.toFixed(2)+ ' mi | '+closed,
                    'url': this.options.locationPath + l.path,
                    'iconSize': [22, 26]
                },
                'geometry': {
                    'type': 'Point',
                    'coordinates': [l.lng, l.lat]
                }
            }
            geojson.features.push(feature)
            return geojson
        },
        services() {
            let services = this.location.services.split(',')
            let text = ''
            for (var i = 0; i < services.length; i++) {
                if (i == 0) {
                    text = services[i].replace(/\_/g, ' ')
                    continue
                }
                text = text + ', ' + services[i].replace(/\_/g, ' ')
            }
            return text
        }
    },
    methods: {
        ...mapActions(['locationSearch']),
        slug(str) {
            return str.replace(/ /g, '-').toLowerCase()
        },
        abbrToState(abbr) {
            abbr = abbr.toUpperCase()
            return stateList[abbr]
        },
        loaded(map) {
            // Add markers to the map.
            for (const marker of this.geojson.features) {
                // Create a DOM element for each marker.
                const el = document.createElement('div')
                const width = marker.properties.iconSize[0]
                const height = marker.properties.iconSize[1]
                el.className = 'marker'
                el.style.backgroundImage = 'url(https://a.storyblok.com/f/120533/x/c3656ea275/icon-marker.svg)'
                el.style.width = `${width}px`
                el.style.height = `${height}px`
                el.style.backgroundSize = '100%'
                el.addEventListener('click', () => {
                    let list = document.querySelectorAll('[data-loc]')
                    for (var i = list.length - 1; i >= 0; i--) {
                        list[i].classList.remove('active')
                    }
                    document.querySelector('[data-loc=' + marker.properties.id + ']').classList.add('active')
                    let html = '<b>' + marker.properties.title + '</b>' + '<p>' + marker.properties.distance + '</p><div class="flex"><a class="btn" href="' + marker.properties.url + '">Store Details</a><a class="btn" href="/order/?store=' + marker.properties.id + '">Order Now</a></div>'
                    if (!marker.properties.available) {
                        html = '<b>' + marker.properties.title + '</b>' + '<p>' + marker.properties.distance + '</p><div class="flex"><a class="btn" href="' + marker.properties.url + '">Store Details</a><a class="btn" href="/menu/">View Menu</a></div>'
                    }
                    // create the popup
                    const popup = new mapboxgl.Popup({ offset: 15 }).setHTML(html)
                    // create the marker
                    el.style.backgroundImage = 'url(https://a.storyblok.com/f/120533/x/105920791f/icon-marker-active.svg)'
                    new mapboxgl.Marker(el)
                        .setLngLat({ lng: marker.geometry.coordinates[0], lat: marker.geometry.coordinates[1] })
                        .setPopup(popup) // sets a popup on this marker
                        .addTo(map)
                    map.flyTo({
                        center: [marker.geometry.coordinates[0], marker.geometry.coordinates[1]],
                        essential: true // this animation is considered essential with respect to prefers-reduced-motion
                        , zoom: 10
                    })
                    popup.on('close', function (e) {
                        el.style.backgroundImage = 'url(https://a.storyblok.com/f/120533/x/c3656ea275/icon-marker.svg)'
                    })
                })
                // Add markers to the map.
                new mapboxgl.Marker(el)
                    .setLngLat(marker.geometry.coordinates)
                    .addTo(map)
            }
        },
        formatPhone(phone) {
            var cleaned = ('' + phone).replace(/\D/g, '');
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3];
            }
            return null;
        },
        getHours(i) {
            if (this.location.hours[i].open == null) {
                return 'Closed'
            }
            if (this.location.hours[i].open == 'closed') {
                return 'Closed'
            } else if (this.location.hours[i].open == this.location.hours[i].close) {
                return 'Open 24 hours'
            } else {
                let string = `${moment(this.location.hours[i].open, 'H:mm').format('h:mma')}-${moment(this.location.hours[i].close, 'H:mm').format('h:mma')}`
                return string.replace(/\:00/g, '')
            }
        },
        getDay(i) {
            return moment(i, 'e').format('ddd')
        },
        async startOrder(location) {
            this.$store.commit('setLocation', location)
            await this.$api.getMenu()
            let order = null
            if (this.order && this.order.menu_id != location.menu_id) {
                order = await this.$api.transferOrder()
            } else {
                order = await this.$api.createOrder()
            }
            if (order) {
                this.$router.push('/order/')
            }
        },
        phone(s) {
            let cleaned = ('' + s).replace(/\D/g, '')
            let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3]
            }
            return null
        },
        openText(loc) {
            if (loc.hours) {
                const day = moment().format('ddd').toLowerCase() // e.g. wed
                let hours = {}
                for (let i = 0; i < loc.hours.length; i++) {
                    if (loc.hours[i].day == day) {
                        hours = loc.hours[i]
                        break
                    }
                }
                if (hours.open) {
                    if (!loc.currently_open) {
                        return 'Opens at ' + moment(hours.date + ' ' + hours.open, 'YYYY-MM-DD H:mm').format('h a')
                    } else {
                        return 'Open til ' + moment(hours.date + ' ' + hours.close, 'YYYY-MM-DD H:mm').format('h a')
                    }
                }
            }
        },
    },
    mounted() {
        // const yext = document.createElement("script")
        // yext.type = 'text/javascript'
        // yext.setAttribute('async', true)
        // yext.setAttribute(
        //   "src",
        //   "https://knowledgetags.yextpages.net/embed?key=007_4DrvCtyXazLGR_1iU5nJ_b13V8-OFoVBENp5oP7U7IKvDKXctOLevRmLv29t&account_id=7112809083039550790&entity_id=" + this.location.id +  "&locale=en&v=20210504"
        // )
        // yext.setAttribute('target', '_blank')
        document.querySelector('main > div').style.flexDirection = 'column'
        const top = document.querySelector('main > div > div')
        top.style.position = 'relative'
        top.style.zIndex = 1

        // START if url has rwg_token param, set cookie.
        function setCookie(name, value, days) {
            document.cookie = `${name}=${value}; path=/;  max-age=${60*60*24*days};`;
        }

        let params = new URL(document.location).searchParams;
        let rwg_token = params.get("rwg_token");
        // console.log('rwg_token:::: ', rwg_token)
        if (rwg_token) {            
            // document.cookie = `rwg_token=${rwg_token}; path=/; max-age=2592000;`;
            setCookie('rwg_token', rwg_token, 30)
        }
        // END if url has rwg_token param, set cookie.
    }
}
